var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3.75","y":"3.75","width":"7.07142","height":"7.07142","rx":"1.82143","stroke":"#23272C","strokeWidth":"1.5","key":0}),React.createElement("rect",{"x":"13.1782","y":"3.75","width":"7.07142","height":"7.07142","rx":"1.82143","stroke":"#23272C","strokeWidth":"1.5","key":1}),React.createElement("rect",{"x":"3.75","y":"13.1782","width":"7.07142","height":"7.07142","rx":"1.82143","stroke":"#23272C","strokeWidth":"1.5","key":2}),React.createElement("rect",{"x":"13.1782","y":"13.1782","width":"7.07142","height":"7.07142","rx":"1.82143","stroke":"#23272C","strokeWidth":"1.5","key":3})]);
}

Grid.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Grid;

Grid.default = Grid;
